import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { AccessManagement } from "@/features/clinical-access/components/AccessManagement";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/access")({
    component: AccessLayout,
});

function AccessLayout() {
    return (
        <AdminPageLayout
            title="Access"
            description="Control user and study access to tabs, clinical catalogues, forms, schedules, and labels."
        >
            <AccessManagement />
            {/* Child routes exist for URL segments; content is driven by pathname in AccessManagement. */}
            <Outlet />
        </AdminPageLayout>
    );
}
